
const imageUtils = {
    HomeBackground: require('../resources/images/home-background.png'),
};

export { imageUtils };
